// Accordion
document.querySelectorAll('.accord-trigger').forEach(btn => {
  btn.addEventListener('click', () => {
    const body = btn.nextElementSibling;
    const isOpen = body.classList.contains('open');
    document.querySelectorAll('.accord-body').forEach(b => b.classList.remove('open'));
    document.querySelectorAll('.accord-trigger span:last-child').forEach(s => s.textContent = '+');
    if (!isOpen) {
      body.classList.add('open');
      btn.querySelector('span:last-child').textContent = '−';
    }
  });
});

// Gallery thumbnails
document.querySelectorAll('.gallery-thumb').forEach(thumb => {
  thumb.addEventListener('click', () => {
    const src = thumb.dataset.src;
    const mainImg = document.getElementById('main-img');
    if (mainImg && src) mainImg.src = src;
    document.querySelectorAll('.gallery-thumb').forEach(t => t.classList.remove('active'));
    thumb.classList.add('active');
  });
});

// Quantity control
function adjQty(delta) {
  const el = document.getElementById('qty');
  if (el) el.value = Math.max(1, parseInt(el.value) + delta);
}

// Variant selector sync
const variantInputs = document.querySelectorAll('.product-form__input input[type=radio]');
const variantSelect = document.getElementById('variant-select');
if (variantInputs.length && variantSelect) {
  variantInputs.forEach(input => {
    input.addEventListener('change', () => {
      const selected = [];
      document.querySelectorAll('.product-form__input').forEach(group => {
        const checked = group.querySelector('input[type=radio]:checked');
        if (checked) selected.push(checked.value);
      });
      const title = selected.join(' / ');
      for (const option of variantSelect.options) {
        if (option.text === title || selected.length === 1) {
          variantSelect.value = option.value;
          break;
        }
      }
    });
  });
}

// Marquee
const mItems = ['LORYÉ Paris','·','Summer 2026','·','New Arrivals','·','Free Worldwide Shipping','·','She Was Always Golden','·','Dressed in Light','·'];
const mq = document.getElementById('mq');
if (mq) {
  [...mItems, ...mItems].forEach(t => {
    const s = document.createElement('span');
    s.className = 'm-item' + (t === '·' ? ' gold' : '');
    s.textContent = t;
    mq.appendChild(s);
  });
}
